const { default: BookingService } = require('services/addBookingService')

export const FunctionPostCTA = async ({ vehicleId, stationsId }) => {
  const res = await BookingService.requestBookingPartnerUrl({ vehicleId, stationsId })
  return res?.data?.bookingUrl || null
}
